import React, { Fragment, useEffect, useState } from "react";
import Container from "@/components/container/Container";
import CardComponent from "@/components/card";
import BackWithLabel from "@/components/common/BackWithLabel";

import "@/styles/pages/guide/guide-dashboard.scss";
import { Flex } from "antd";
import Resources from "@/components/resources/Resources";
import SessionCardHoc from "@/pages/guide/components/SessionCardHoc";
import { getIsGuidePanel, setIsGuidePanel } from "@/reducers/guideSlice";
import { useDispatch, useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import { getUserInfo } from "@/reducers/commonSlice";
import { getGuideProfile } from "@/services/guides/getGuideProfile";
import { getMissingFields } from "@/helpers";
import { getUserAvailability } from "@/services/users/getUserAvailability";

const sessionData = [
  {
    picture: "/assets/images/profile.svg",
    name: "Roonie Shukla",
    sessionName: "1-on-1 Call Session",
    date: "22 March 2024",
    time: "07:30pm (IST)",
  },
];

const GuideDashboard = () => {
  const isGuidePanel = useSelector(getIsGuidePanel);
  const userData = useSelector(getUserInfo);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [isProfileIncomplete, setIsProfileIncomplete] = useState(false);
  const [availbilityMissing, setAvailabilityMissing] = useState(null);
  const [dpMissing, setDpMissing] = useState(false);

  // add check of missing DP in basic info profile

  const handleSwitchToStudentPanel = () => {
    dispatch(setIsGuidePanel(!isGuidePanel));
    navigate("/dashboard");
  };

  useEffect(() => {
    getGuideProfile().then((data) => {
      const missing = getMissingFields(data);
      console.log("Missing fields:", missing);
      setIsProfileIncomplete(missing.length > 0 && !missing.includes("profileImgUrl"));
      setDpMissing(missing.includes("profileImgUrl"));

      getUserAvailability().then((res) => {
        if (res === null) {
          setAvailabilityMissing(true);
        }
      });
    });
  }, []);

  return (
    <Fragment>
      <div className="guide-dashboard-wrapper">
        <Container>
          {!userData?.verified?.email ? (
            <p
              style={{
                color: "red",
                fontSize: "16px",
                fontWeight: "bold",
                margin: "10px 0",
              }}
            >
              ⚠️ Your email is not verified or Profile Pic is missing. Please{" "}
              <Link
                to="/profile/basic-contact-information"
                style={{
                  color: "red",
                  textDecoration: "underline",
                  fontWeight: "bold",
                }}
              >
                verify your email
              </Link>
              .
            </p>
          ) : null}
          {isProfileIncomplete && (
            <div
              style={{
                color: "red",
                fontSize: "16px",
                fontWeight: "bold",
                margin: "10px 0",
                padding: "10px",
                backgroundColor: "#ffe6e6",
                border: "1px solid red",
                borderRadius: "5px",
              }}
            >
              ⚠️ Your mentor profile is incomplete. Please{" "}
              <Link
                to="/profile/basic-profile-detail"
                style={{
                  color: "red",
                  textDecoration: "underline",
                  fontWeight: "bold",
                }}
              >
                complete your profile
              </Link>{" "}
              to be visible in the mentor search.
            </div>
          )}

          {dpMissing && (
            <div
              style={{
                color: "red",
                fontSize: "16px",
                fontWeight: "bold",
                margin: "10px 0",
                padding: "10px",
                backgroundColor: "#ffe6e6",
                border: "1px solid red",
                borderRadius: "5px",
              }}
            >
              ⚠️ Your profile image is missing. Please{" "}
              <Link
                to="/profile/basic-contact-information"
                style={{
                  color: "red",
                  textDecoration: "underline",
                  fontWeight: "bold",
                }}
              >
                add your profile image
              </Link>{" "}
              here.
            </div>
          )}
          {availbilityMissing && (
            <div
              style={{
                color: "red",
                fontSize: "16px",
                fontWeight: "bold",
                margin: "10px 0",
                padding: "10px",
                backgroundColor: "#ffe6e6",
                border: "1px solid red",
                borderRadius: "5px",
              }}
            >
              ⚠️ Your Availibility is not set. Please{" "}
              <Link
                to="/availability"
                style={{
                  color: "red",
                  textDecoration: "underline",
                  fontWeight: "bold",
                }}
              >
                update your availability
              </Link>{" "}
              so that students can book sessions with you.
            </div>
          )}
          <CardComponent>
            <Flex className="header" justify="space-between" align="center">
              <BackWithLabel label="Dashboard" />
              <span className="color-brand cursor-pointer" onClick={handleSwitchToStudentPanel}>
                Switch to Student dashboard
              </span>
            </Flex>
            {/* <div className="session-header">
              <div className="heading body-b3">Today’s Session</div>
              <div className="view-all body-b4-1">View All</div>
            </div> */}
            <SessionCardHoc />
            <div className="sessions">
              {/* <Row gutter={[16, 16]}>
                {sessionData.map((item, index) => {
                  return (
                    <Col xxl={8} xl={8} lg={12} md={24} sm={24} xs={24}>
                      <div className="session-card">
                        <CardComponent>
                          <div className="session-card-header">
                            <div className="context">Session with</div>
                            <div className="close-button">
                              <IconCross color="#fdfefe" />
                            </div>
                          </div>

                          <div className="name">
                            <div className="picture">
                              <img src={item.picture} alt="" />
                            </div>

                            <div className="fullname body-b2">{item.name}</div>
                          </div>

                          <div className="sesstion-name">
                            <IconSessionName />
                            &nbsp;<span>Session Name:</span>&nbsp;
                            {item.sessionName}
                          </div>

                          <div className="session-date">
                            <IconCalender />
                            &nbsp;<span>Date:</span>&nbsp;{item.date}
                          </div>

                          <div className="session-time">
                            <IconSessionTime />
                            &nbsp;<span>Time:</span>&nbsp;{item.time}
                          </div>

                          <div className="session-button">
                            <ButtonComponent
                              varient="success"
                              label="Start Session"
                            ></ButtonComponent>
                          </div>
                        </CardComponent>
                      </div>
                    </Col>
                  );
                })}
              </Row> */}
            </div>
            <div className="resources">
              <div className="resources-section">
                <div className="heading body-b3">My Resources</div>
              </div>
              <div className="resource-buttons">
                <Resources />
              </div>
            </div>
          </CardComponent>
        </Container>
      </div>
    </Fragment>
  );
};

export default GuideDashboard;
